import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} home`,
    languageButtonLabel: `Language`,
    languageModalTitle: `Choose a language`,
    languageModalCloseLabel: `Close language menu`,
  },
  languageOptions: {
    'en-US': {
      label: `English`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `English (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `English (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `English (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Português`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Deutsch`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Español`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Français`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiano`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Nederlands`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Nordisk`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `日本語`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `한국어`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `普通话`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `廣東話`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `ไทย`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `हिन्दी`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `فارسی`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Русский`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `العربية`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `الدارجة المغربية`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Choose a language`,
    closeLabel: `Close language menu`,
  },
  languageHint: (ctx) => `Locale hopping across ${ctx.localesCount}+ locales.`,
  readPagePrompt: ({languageLabel}) => `Read this page in ${languageLabel}.`,
};
